import { AttachMoney } from "@mui/icons-material";
import UserMenuItem from "./UserMenuItem";
import { useServices } from "../../services/Services";
import { FC } from "react";

const StripeBillingItem: FC<object> = () => {
  const services = useServices();
  const { data: user } = services.User.useGetCurrent();
  const { data: stripeDetails } = services.User.useGetStripeDetails(
    user?.email,
  );
  const canManageBilling = stripeDetails?.canManageBilling;
  const stripeLink = stripeDetails?.billingPortalUrl;
  const stripeEnabled = canManageBilling && stripeLink;

  return (
    <UserMenuItem
      Icon={AttachMoney}
      disabled={!stripeEnabled}
      to={stripeLink}
      target="_blank"
    >
      Manage Subscription
    </UserMenuItem>
  );
};

export default StripeBillingItem;
